export default __webpack_public_path__ + "static/chagas-83b30bb6189994b94f98b43f5de7e3e5.webp";